import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { getTenantRentPaymentList } from './RentedPropertiesAPI'
import { CircularProgress } from '@mui/material'
import { PageLink } from '../../../_metronic/layout/core'
import { tenantPaymentListDataType } from './RentedPropertiesDataType'
import PaginationComponent from '../PaginationComponent/Pagination'
import MarkAsPaid from '../property/RentInfo/Components/MarkAsPaid'
import InvoiceTypeSubmenu from './Components/InvoiceTypeSubmenu'
import styles from '../KYCDetails/KYCDetailsStyles/KYCDetailsStyle.module.scss'

const profileBreadCrumbs: Array<PageLink> = [
  { title: 'Rent Information', path: '/overview', isSeparator: false, isActive: false },
  { title: '', path: '', isSeparator: true, isActive: false },
]
const RentedPropertiesDetailPage = () => {
  const { id } = useParams()
  const [noDataFound, setNoDataFound] = useState<boolean>(false)
  const [tenantPaymentList, setTenantPaymentList] = useState<tenantPaymentListDataType[]>()
  const [loading, setLoading] = useState<boolean>(false)
  const [showMarkAsPaid, setShowMarkAsPaid] = useState<string | undefined>()
  const [showInvoice, setShowInvoice] = useState<string | null>(null)
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [dataLength, setDataLength] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(dataLength / itemsPerPage)

  async function getListTenantRentPayment() {
    if (id) {
      setLoading(true)
      try {
        const response = await getTenantRentPaymentList(id, itemOffset, itemsPerPage)
        if (response.status === 200) {
          if (!Array.isArray(response?.data?.data) && response?.data?.data?.rentList?.length !== 0) {
            setNoDataFound(false)
            setDataLength(response.data.data.totalRentList)
            setTenantPaymentList(response.data.data.rentList)
          } else if (Array.isArray(response?.data?.data) && response?.data?.data?.length === 0) {
            setNoDataFound(true)
          }
          else{
            setNoDataFound(true)
          }
        } else {
          setNoDataFound(true)
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
            text: response.data.msg_details,
            allowOutsideClick: true,
          })
        }
      } catch (error: any) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error,
        })
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    getListTenantRentPayment()
  }, [itemOffset])

  const FormatDate = (date: Date) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formattedDate
  }
  const FormatDateMMMYY = (date: Date) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: '2-digit',
      month: 'short',
    })
    return formattedDate
  }

  const LOCAL_URL = process.env.REACT_APP_LOCALHOST
  const handleShowInvoice = (proforma_invoice_link: string, utility_invoice_link: string) => {
    if (showInvoice === proforma_invoice_link) {
      setShowInvoice(null);
    }
    else if (showInvoice === utility_invoice_link) {
      setShowInvoice(null);
    }
    else if (proforma_invoice_link || utility_invoice_link) {
      if (proforma_invoice_link) {
        setShowInvoice(proforma_invoice_link);
      } else if (utility_invoice_link) {
        setShowInvoice(utility_invoice_link);
      } else {
        setShowInvoice(null);
      }
    }
    else {
      setShowInvoice(null);
    }
  };
  return (
    <>
      {loading ? (
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{ height: '70vh' }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
            <div className='d-flex flex-column flex-column-fluid'>
              {/* Begin: header for property page */}
              <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
                <div className='d-flex flex-column'>
                  {/* Begin: Heading */}
                  <h1
                    className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center pb-2'
                  >
                    Rent Information
                  </h1>
                  <p className='breadcrumb text-muted fs-6 fw-bold'>Property: {tenantPaymentList &&
                    tenantPaymentList.length > 0 &&
                    tenantPaymentList[0].property_title}</p>
                </div>
                {/* End: Heading */}
              </div>
              {/* End: header for property page */}

              {/* Begin: Table */}
              <div id='table div'>
                <div className={`card mb-5 mb-xl-8`}>
                  <div className='card-body py-3'>
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        {!noDataFound && (
                          <thead>
                            <tr className='fw-bold text-muted'>
                              {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                              <th className='max-w-150px'>Rent Month</th>
                              <th className='max-w-150px'>Rent Amount</th>
                              <th className='max-w-150px'>Rent Due Date</th>
                              <th className='max-w-150px'>Status</th>
                              <th className='max-w-150px'>Actions</th>
                            </tr>
                          </thead>
                        )}
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {noDataFound ? (
                            <tr>
                              <td colSpan={5}>
                                <span className='d-flex flex-column align-items-center flex-start p-10'>
                                  <img
                                    src='/media/svg/undraw/online_payments.svg'
                                    alt='No document uploaded'
                                    className='h-200px w-200px'
                                  />
                                  <span className='fw-bold text-muted fs-1 text-center'>
                                    No transactions present
                                  </span>
                                </span>
                              </td>
                            </tr>
                          ) : (
                            tenantPaymentList?.map((payment, index: number) => {
                              return (
                                <tr key={index}>
                                  <td className='max-w-150px'>
                                    <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                      {FormatDateMMMYY(new Date(payment.tenant_rent_due_date))}
                                    </div>
                                  </td>
                                  <td className='max-w-150px'>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                      {`₹ ${payment.tenant_rent_amount}`}
                                    </span>
                                  </td>
                                  <td className='max-w-150px'>
                                    <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                      {FormatDate(new Date(payment.tenant_rent_due_date))}
                                    </span>
                                  </td>
                                  <td className='max-w-150px'>
                                    <span
                                      className={`badge ${payment.tenant_rent_status_name.toLowerCase() === 'pending'
                                        ? 'badge-light-warning'
                                        : payment.tenant_rent_status_name.toLowerCase() === 'processing'
                                          ? `${styles.status_processing}` :
                                          payment.tenant_rent_status_name.toLowerCase() === 'completed'
                                            ? 'badge-light-success' :
                                            payment.tenant_rent_status_name.toLowerCase() === 'failed'
                                              ? 'badge-light-danger' :
                                              payment.tenant_rent_status_name.toLowerCase() === 'overdue'
                                                ? 'badge-light-danger' :
                                                'badge-light-primary'
                                        } fs-8 fw-bold`}
                                    >
                                      {payment.tenant_rent_status_name.charAt(0).toUpperCase() + payment.tenant_rent_status_name.slice(1)}
                                    </span>
                                  </td>
                                  <td className='max-w-250px'>
                                    <div className='d-flex flex-shrink-0'>
                                      {
                                        (payment.proforma_invoice_link || payment.utility_invoice_link) &&
                                        <div className='app-navbar-item'>
                                          <button
                                            className='position-relative cursor-pointer border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            title='Invoice'
                                            onClick={()=>handleShowInvoice(payment.proforma_invoice_link, payment.utility_invoice_link)}
                                          >
                                            <i className='bi bi-receipt bi-4x fs-3'></i>
                                          </button>
                                          <>
                                            {
                                              (showInvoice === (payment.proforma_invoice_link || payment.utility_invoice_link)) &&
                                              <InvoiceTypeSubmenu
                                                utility_invoice_link={payment.utility_invoice_link}
                                                proforma_invoice_link={payment.proforma_invoice_link}
                                                setShowInvoice={setShowInvoice}
                                              />
                                            }
                                          </>
                                        </div>
                                      }
                                      {/* // <Link
                                        //   to={payment.proforma_invoice_link}
                                        //   target='_blank'
                                        //   className='border-0 btn btn-icon btn-bg-light  btn-active-color-primary btn-sm me-1'
                                        //   title='Invoice'>
                                        //   <i className='bi bi-receipt bi-4x fs-3'></i>
                                        // </Link> */}

                                      {payment.tenant_rent_status_name.toLowerCase() === 'completed' ? (
                                        <Link
                                          to={payment.receipt_link}
                                          target='_blank'
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          title='Download receipt'
                                        >
                                          <i className='bi bi-download fs-3'></i>
                                        </Link>
                                      ) : payment.tenant_rent_status_name.toLowerCase() !== 'processing' && (
                                        <>
                                          <Link to={`${LOCAL_URL}/transaction/tenantPayment/?uid=${payment.tenant_rent_uuid}`}
                                            className='border-0 btn btn-icon btn-bg-light  btn-active-color-primary btn-sm me-1'
                                            title='Pay rent'
                                            onClick={() => localStorage.setItem('tenant_rent_uuid', id ? id : "")}>
                                            <i className='bi bi-cash-stack bi-4x fs-3'></i>
                                          </Link>
                                          <button
                                            className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            onClick={() => setShowMarkAsPaid(payment.tenant_rent_uuid)}
                                          >
                                            <i className='bi bi-check-square fs-3' title='Mark as Paid'></i>
                                          </button>
                                          {showMarkAsPaid === payment.tenant_rent_uuid && (
                                            <MarkAsPaid
                                              rentDetails={payment}
                                              show={true}
                                              handleClose={() => setShowMarkAsPaid(undefined)}
                                              getTenantRentPaymentList={getListTenantRentPayment}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Begin: Pagination */}
          {
            tenantPaymentList && pageCount > 1 && <PaginationComponent itemsPerPage={itemsPerPage} dataLength={dataLength} setItemOffset={setItemOffset} currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} />
          }
          {/* End: Pagination */}
        </>
      )}
    </>
  )
}

export default RentedPropertiesDetailPage
